import React from "react";
export const VsIcon = () => (
  <svg
    width="54"
    height="54"
    viewBox="0 0 54 54"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.534473"
      y="0.624316"
      width="52.9271"
      height="52.9271"
      rx="26.4636"
      fill="white"
    />
    <rect
      x="0.534473"
      y="0.624316"
      width="52.9271"
      height="52.9271"
      rx="26.4636"
      stroke="#DADADA"
      stroke-width="0.89707"
    />
    <path
      d="M20.992 33.2148L17.2135 21.5888H18.9655L22.1869 31.5113L25.4487 21.5888H27.2006L23.4222 33.2148H20.992ZM31.9136 33.4571C31.0793 33.4571 30.3258 33.3144 29.653 33.0292C28.9856 32.7385 28.4339 32.3267 27.9979 31.7939C27.5673 31.2556 27.2874 30.6178 27.1582 29.8804L28.9183 29.614C29.0959 30.3245 29.4673 30.8789 30.0325 31.2772C30.5976 31.6701 31.257 31.8665 32.0105 31.8665C32.4788 31.8665 32.9094 31.7939 33.3023 31.6486C33.6952 31.4979 34.0101 31.2852 34.2469 31.0107C34.4891 30.7309 34.6102 30.3971 34.6102 30.0096C34.6102 29.7997 34.5725 29.614 34.4972 29.4525C34.4272 29.2911 34.3276 29.1511 34.1985 29.0327C34.0747 28.9089 33.9213 28.8039 33.7383 28.7178C33.5606 28.6263 33.3642 28.5483 33.1489 28.4837L30.1697 27.6037C29.8791 27.5176 29.583 27.4072 29.2816 27.2726C28.9802 27.1327 28.703 26.9524 28.45 26.7317C28.2024 26.5057 28.0006 26.2285 27.8445 25.9001C27.6884 25.5664 27.6104 25.1627 27.6104 24.6891C27.6104 23.9732 27.7934 23.3677 28.1594 22.8725C28.5308 22.372 29.0313 21.9952 29.6611 21.7422C30.2908 21.4839 30.9959 21.3547 31.7764 21.3547C32.5622 21.3654 33.2646 21.5054 33.8836 21.7745C34.5079 22.0436 35.0247 22.4312 35.4337 22.9371C35.8482 23.4377 36.1334 24.0459 36.2895 24.7618L34.481 25.0685C34.4003 24.6326 34.2281 24.2585 33.9643 23.9463C33.7006 23.6288 33.3776 23.3865 32.9955 23.2197C32.6133 23.0474 32.1989 22.9586 31.7521 22.9533C31.3215 22.9425 30.9259 23.0071 30.5653 23.147C30.2101 23.287 29.9248 23.4834 29.7095 23.7364C29.4996 23.9894 29.3946 24.28 29.3946 24.6084C29.3946 24.9313 29.4888 25.1923 29.6772 25.3915C29.8656 25.5906 30.097 25.7494 30.3716 25.8678C30.6514 25.9809 30.9286 26.0751 31.2031 26.1504L33.3507 26.7559C33.6198 26.8313 33.9239 26.9336 34.263 27.0627C34.6075 27.1865 34.9385 27.3615 35.2561 27.5875C35.579 27.8136 35.8455 28.115 36.0554 28.4918C36.2653 28.8632 36.3703 29.3314 36.3703 29.8966C36.3703 30.4833 36.2518 31 36.015 31.4467C35.7782 31.8881 35.4526 32.2595 35.0381 32.5609C34.629 32.8569 34.1554 33.0803 33.6172 33.231C33.0789 33.3817 32.5111 33.4571 31.9136 33.4571Z"
      fill="#262626"
    />
  </svg>
);
